import { ref, toValue, watch } from '#imports';
import type { MaybeRefOrGetter } from 'vue';

const NOVINCE_TYPE = {
  FRESH: 1, //注册小于两周
  GROWTH: 2, //注册大于两周
};
export const useFreshTasksPlacement = (
  noviceType: MaybeRefOrGetter<number | undefined>,
) => {
  const isPriority = ref(false);
  watch(() => toValue(noviceType), (newVal) => {
    if (newVal === NOVINCE_TYPE.FRESH) {
      isPriority.value = true;
    } else {
      isPriority.value = false;
    }
  }, { immediate: true });
  return {
    isPriority,
  };
};
